<template>
  <tab-item-template>
    <template #toolbar-items>
      <v-spacer/>
      <v-btn text color="white" :to="{ name: '/edit/list/serviceImplementation/ServiceImplementationList', params: { controllerId: controllerId } }">
        <v-icon class="mr-1">icon-service_implementation</v-icon>
        サービス実装管理
      </v-btn>
    </template>

    <el-table
        :data="serviceImplementationsView">
      <el-table-column
          min-width="35"
          prop="name"
          label="名称">
      </el-table-column>

      <el-table-column
          min-width="35"
          prop="description"
          label="説明">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.description"
                placeholder="未設定"
                multi-line>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
           min-width="35"
           prop="status"
           label="ステータス">
         <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="serviceImplementationStatuses[row.status]"
                placeholder="未設定"
                hide-details
                dense>
            </text-field-like>
          </table-inline>
         </template>
       </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import gql from "graphql-tag";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import BetterSet from "betterset";
import { SERVICE_IMPLEMENTATION_STATUSES } from "@/constants";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";

export default {
  name: 'ServiceImplementationTable',
  mixins: [
    PathInfoMixin
  ],
  components: {
    TabItemTemplate,
    TextFieldLike,
    TableInline
  },
  props: {
    serviceImplementations: {
      type: Array,
      required: true
    },
    controllerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      serviceComponentModels: [],
      serviceImplementationStatuses: SERVICE_IMPLEMENTATION_STATUSES
    }
  },
  computed: {
    serviceImplementationsView() {
      return this.serviceImplementations.map(si => {
        const scm = this.serviceComponentModels.find(scm => scm.id === si.serviceComponentModelId);
        return {
          ...si,
          name: scm?.name,
          description: scm?.description
        };
      });
    }
  },
  methods: {
    ...mapActions({
      gqlQuery: 'hds/gqlQuery',
    }),
    openCreateDialog() {
      this.dialogCreate = [];
    }
  },
  watch: {
    serviceImplementations: {
      immediate: true,
      async handler(serviceImplementations) {
        // サービス実装に使用されているサービス構成モデルを取得
        const serviceComponentModelIds = serviceImplementations
            .map(si => si.serviceComponentModelId)
            .reduce((set, value) => {set.add(value); return set;}, new BetterSet())
            .asArray();
        if(serviceComponentModelIds.length === 0) {
          this.serviceComponentModels = [];
          return;
        }

        const {serviceComponentModels} = await this.gqlQuery({
          query: gql`
            query FindServiceComponentModels(
                $serviceComponentModelIds: [ID!]!,
            ) {
                serviceComponentModels: serviceComponentModelInBulk(serviceComponentModelIds: $serviceComponentModelIds) {
                    id
                    name
                    description
                }
            }`,
          variables: {
            serviceComponentModelIds
          },
        });
        this.serviceComponentModels = serviceComponentModels;
      }
    }
  }
}
</script>
